export default {
  // -activityflash---------------
  metaTitle: 'Apply for Flash',
  pageTitle: 'Apply for Promotion',
  content: 'The current type and specifications of Promotion applied',
  flashsale: 'Flashsale',
  placeholder1: 'Listing#',
  placeholder2: 'Sku#',
  placeholder3: 'Listing Title',
  placeholder4: 'Store Category',
  placeholder5: 'Select the Up-shelf time',
  filter: 'Filter',
  submitBtn: 'Submit Application',
  buttonName: 'Platform category',
  buttonName2: 'Category',
  columns1: 'Select All',
  columns2: 'Listing ID',
  columns3: 'Title',
  columns4: 'Price(Min)',
  columns5: 'Price(max)',
  columns6: 'Active Aku Count',
  sessions1: 'Morning Session',
  sessions2: 'Afernoon Session',
  sessions3: 'Evening Session',
  // ---activitypromotion----------------------------
  metaTitle2: 'Apply for Group-Promotion',
  promotion: 'Promotion (reduction on Amount)',
  confirmContent: 'Are you sure to confirm',
  // ---activitygroup------------------------------
  metaTitle1: 'Apply for Group-on',
  main1: 'Group-on',
  main2: 'day validity',
  main3: 'Group-on for',
  main4: 'Expires in',
  main5: 'hours',
  main6: 'Expected start time',
  // ----activitytd---------------------
  metaTitle3: 'Apply for TD',
  today1: 'Today\'s Deal',
  today2: 'Days',

  startTime: 'Start Time',
  endTime: 'End Time',

  actSubTitle: 'Fill in Product Information for Campaign',
  setPriceLJ: 'Reduce',
  batchPriceSetting: 'Set Prices in Bulk',
  discountLowestTips: `This product has a discount of over 50%. Please check the campaign price and make sure you can supply the product and complete orders at this price.
After the campaign starts, an approved registration cannot be canceled.You shall bear all economic losses caused by incorrect price entry due to your own reasons.
By clicking “Confirm“, you confirm that you understand these risks and can complete orders at the price you submitted.`,
  discountLowestTitle: 'Price Too Low Risk Warning',

  setPriceLabel1: 'Set Standard Prices',
  setPriceLabel2: 'Deduct Fixed Amount',
  setPriceLabel3: 'Add Fixed Amount',
  setPriceLabel4: 'Deduct by Percentage',

  submit: 'Submit',

  subRegTips: 'Are you sure to submit?',
  subRegTipsTitle: 'Tip',
  confirm: 'Confirm',
  cancel: 'Cancel',
  submitOk: 'Submitted successfully',
  submitBtnText: 'Submit',
  regNameAndType: 'The current registration campaign:',

  selectType: 'Select',
  setPriceTips: 'Only integers are supported for input. For example, to reduce by 80%, enter 80. Any decimals like 80.9 will be rounded down to 80%.',
  setPriceTips1: 'Add or subtract from the selling price, for example, -10 means a deduction of 10 from the price of all registered product SKUs as the promotional price',
  setPriceTips2: 'All registered product SKUs have been set to a specified price. Please choose this option carefully',
  priceNullTips: 'Please enter the event price for all Skus',

  historyPriceLabel: 'Historical Low Price',
  historyPriceTips: 'Lowest Selling Price in the Last 30 Days (Excluding Flash Sale Price)',

  imageLabel: 'Image',
  skuInfoLabel: 'SKU Info',
  titleLabel: 'Title',
  salePriceLabel: 'Sale Price (KSh)',
  dealPriceLabel: 'Deal Price (KSh)',
  operationLabel: 'Operation'
}
